import { useModuleBEM } from "@b2bportal/core-themes";
import type {
  PackageItinerary,
  PaymentBreakdown,
} from "@b2bportal/rbc-bundled-packages-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { usePackageCheckoutBreakdown } from "../../hooks/usePackageCheckoutBreakdown";
import styles from "./PackageCheckoutBreakdown.module.scss";

interface PackageCheckoutBreakdownProps {
  pricingBreakdown: PackageItinerary["pricingBreakdown"];
  paymentBreakdown: PaymentBreakdown | undefined;
  hotelData: any;
  flightData: any;
  hasGround: boolean;
}

export const PackageCheckoutBreakdown = ({
  pricingBreakdown,
  paymentBreakdown,
  hotelData,
  flightData,
  hasGround,
}: PackageCheckoutBreakdownProps) => {
  const [block, cn] = useModuleBEM(styles, "PackageCheckoutBreakdown");
  const { t } = useI18nContext();

  const {
    subtitle,
    total,
    pointsRedeemed,
    pointsRedeemedFiat,
    travelCreditApplied,
    amountPaid,
    paymentMethod,
    hasPayLater,
    payLater,
  } = usePackageCheckoutBreakdown({
    pricingBreakdown,
    paymentBreakdown,
    hotelData,
    flightData,
    hasGround,
  });

  return (
    <div className={block}>
      <div className={cn("container")}>
        <p className={cn("title")}>{t("trips.checkoutBreakdown")}</p>
        {subtitle && <p className={cn("subtitle")}>{subtitle}</p>}
      </div>

      {total && (
        <div className={cn("container")}>
          <div className={cn("row", ["title"])}>
            <div>{t("total")}</div>
            <div>{total}</div>
          </div>
          {travelCreditApplied && (
            <div className={cn("row")}>
              <div>{t("trips.travelCreditsApplied")}</div>
              <div className={cn("points-value")}>{travelCreditApplied}</div>
            </div>
          )}
          {pointsRedeemed && pointsRedeemedFiat && (
            <div className={cn("row")}>
              <div>
                {t("rewards.priceBreakdown.pointsApplied", {
                  points: pointsRedeemed,
                })}
              </div>
              <div className={cn("points-value")}>{pointsRedeemedFiat}</div>
            </div>
          )}
        </div>
      )}

      {amountPaid && (
        <div className={cn("container")}>
          <div className={cn("row", ["title"])}>
            <div>{t("trips.amountPaid")}</div>
            <div>{amountPaid}</div>
          </div>
          {paymentMethod && (
            <div className={cn("row")}>
              <div>{t("trips.paymentMethod")}</div>
              <div>{paymentMethod}</div>
            </div>
          )}
        </div>
      )}

      {hasPayLater && payLater && (
        <div className={cn("pay-at-property")}>
          <span className={cn("pay-at-property-title")}>
            {t("lodgingPriceBreakdown.payAtProperty")}
          </span>
          <div className={cn("pay-at-property-divider")} />
          <div className={cn("pay-at-property-total")}>
            <span>{t("lodgingPriceBreakdown.totalDueAtCheckIn")}</span>
            <span>{payLater}</span>
          </div>
        </div>
      )}
    </div>
  );
};
